class DpoUiOverride extends HTMLElement {
  constructor() {
    super();

    this.DPO_CLASS = "has_dpo_options";
    this.FILLED_CLASS = "dpo_field_filled";
    this.CHECKMARK = "✓";
  }

  connectedCallback() {
    waitForDpo(() => this.init());
  }

  disconnectedCallback() {}

  _hasDpoOptions() {
    return document.body.classList.contains("has_dpo_options");
  }

  _getInputs(dpoConfigurator) {
    if (!dpoConfigurator) return [];

    const selects = dpoConfigurator.querySelectorAll('.control > select');
    const checkboxes = dpoConfigurator.querySelectorAll('.control input[type="checkbox"]');
    
    return [...Array.from(selects), ...Array.from(checkboxes)];
  }  

  _attachListener(input) {
    const isCheckbox = input.type === 'checkbox';

    const update = () => {
      const filled = isCheckbox
        ? input.checked
        : (input.selectedIndex !== 0 || input.value !== '');

      const parentContainer = input.closest('.fields') || input.closest('.field');
      if (!parentContainer) return;

      parentContainer.classList.toggle(this.FILLED_CLASS, filled);
    };

    input.addEventListener('change', update);
    update();
  }

  _injectDomElements() {
    const dpoContainer = document.querySelector(".dpo-container");

    if (dpoContainer) {
      dpoContainer.insertAdjacentHTML("afterbegin", this.innerHTML);
      this.remove();
    }
  }

  init() {
    if (!this._hasDpoOptions()) return;
    this._injectDomElements();

    this.dpoConfigurator = document.querySelector("#itoris_dynamicproductoptions");
    if (!this.dpoConfigurator) return;

    const inputs = this._getInputs(this.dpoConfigurator);
    if (inputs.length === 0) return;

    inputs.forEach((input) => this._attachListener(input));

    const applyFilled = () => {
      inputs.forEach((input) => {
        const isCheckbox = input.type === 'checkbox';
        const filled = isCheckbox ? input.checked : (input.selectedIndex !== 0 || input.value !== '');

        const container = input.closest(".fields");
        if (!container) return;

        container.classList.toggle(this.FILLED_CLASS, filled);
      });
    };

    const observer = new MutationObserver(applyFilled);
    inputs.forEach((input) => {
      observer.observe(input, {
        attributes: true,
        attributeFilter: ["value"],
      });
    });

    setTimeout(() => {
      observer.disconnect();
      applyFilled();
    }, 500);
  }
}

customElements.define("dpo-ui-override", DpoUiOverride);
